var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "#FF7518"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5C9.04784 5 7.57176 5 7.14161 5.90943C7.10463 5.9876 7.07344 6.0688 7.04832 6.15227C6.75612 7.12331 7.79987 8.24878 9.88736 10.4997L11.2857 12H12.7143L14.1126 10.4997C16.2001 8.24878 17.2439 7.12331 16.9517 6.15227C16.9266 6.0688 16.8954 5.9876 16.8584 5.90943C16.4282 5 14.9522 5 12 5ZM10.5714 6.925C10.2756 6.925 10.0357 7.16005 10.0357 7.45C10.0357 7.73995 10.2756 7.975 10.5714 7.975H13.4286C13.7244 7.975 13.9643 7.73995 13.9643 7.45C13.9643 7.16005 13.7244 6.925 13.4286 6.925H10.5714Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14161 18.0906C7.57176 19 9.04784 19 12 19C14.9522 19 16.4282 19 16.8584 18.0906C16.8954 18.0124 16.9266 17.9312 16.9517 17.8477C17.2439 16.8767 16.2001 15.7512 14.1126 13.5003L12.7143 12H11.2857L9.88736 13.5003C7.79987 15.7512 6.75612 16.8767 7.04832 17.8477C7.07344 17.9312 7.10463 18.0124 7.14161 18.0906Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5455 16C10.2442 16 10 16.2239 10 16.5C10 16.7761 10.2442 17 10.5455 17H13.4545C13.7558 17 14 16.7761 14 16.5C14 16.2239 13.7558 16 13.4545 16H10.5455Z",
    fill: "#FF7518"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentPending);
export default __webpack_public_path__ + "static/media/payment-pending.3e446157d1cd72b498130602e7470b0e.svg";
export { ForwardRef as ReactComponent };